import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPointerCursor = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M6.90816 1.8941C6.00568 1.66847 5.28328 1.48786 4.70657 1.39859C4.12477 1.30853 3.58692 1.29212 3.09589 1.48441C2.35673 1.77386 1.77191 2.35868 1.48245 3.09785C1.29016 3.58888 1.30658 4.12672 1.39664 4.70852C1.48591 5.28524 1.66651 6.00763 1.89214 6.91011L2.79497 10.5214C2.99028 11.3027 3.14156 11.9078 3.27172 12.3569C3.39578 12.785 3.52445 13.1634 3.70243 13.4243C4.78267 15.0078 7.0871 15.0935 8.28204 13.5948C8.47893 13.3478 8.63536 12.98 8.7909 12.5623C8.95408 12.1241 9.1499 11.5319 9.40274 10.7674L9.40763 10.7526C9.50539 10.457 9.53698 10.3655 9.5746 10.2871C9.7237 9.97629 9.97435 9.72564 10.2852 9.57654C10.3636 9.53893 10.455 9.50734 10.7507 9.40957L10.7654 9.40469C11.5299 9.15188 12.1222 8.95602 12.5603 8.79286C12.978 8.63732 13.3458 8.48088 13.5928 8.284C15.0916 7.08906 15.0058 4.78462 13.4224 3.70438C13.1615 3.5264 12.7831 3.39773 12.355 3.27367C11.9058 3.14351 11.3007 2.99224 10.5195 2.79692L6.90816 1.8941Z",
		fill: "#9333EA"
	})
});
const ForwardRef = forwardRef(SvgPointerCursor);
export default ForwardRef;
